import { FileText, PlusSquare, UserPlus, Users } from "lucide-react";
import {
  DashboardQuickAccess,
  type DashboardQuickAccessConfig,
} from "../dashboard/DashboardQuickAccess";

type QuickAccessItem = {
  id: "admissions" | "invoices" | "agents" | "beneficiaries";
  href: string;
  label: string;
};

type EnterpriseDashboardQuickAccessProps = {
  items: QuickAccessItem[];
  activeId: string;
  onSelect: (id: string) => void;
};

const quickAccessConfig: Record<QuickAccessItem["id"], DashboardQuickAccessConfig> = {
  admissions: {
    icon: PlusSquare,
    cardClassName:
      "!border-green !bg-green shadow-[0_8px_24px_rgba(184,228,23,0.22)] hover:!brightness-[0.97]",
    activeClassName: "ring-2 ring-green ring-offset-2 ring-offset-card",
    iconClassName: "bg-white/45 text-primary shadow-sm",
    labelClassName: "font-semibold text-primary",
  },
  invoices: {
    icon: FileText,
    cardClassName:
      "!border-primary/45 !bg-white hover:!border-primary/65 dark:!bg-white",
    activeClassName: "ring-2 ring-primary ring-offset-2 ring-offset-card",
    iconClassName: "bg-primary text-white shadow-sm",
    labelClassName: "font-semibold text-primary",
  },
  agents: {
    icon: UserPlus,
    cardClassName:
      "!border-yellow-400/50 !bg-yellow-400/20 hover:!bg-yellow-400/28 dark:!border-yellow-500/40 dark:!bg-yellow-500/15",
    activeClassName: "ring-2 ring-yellow-400/60 ring-offset-2 ring-offset-card",
    iconClassName: "bg-yellow-400/30 text-amber-800 shadow-sm dark:text-primary",
    labelClassName: "font-semibold text-foreground",
  },
  beneficiaries: {
    icon: Users,
    cardClassName:
      "!border-yellow/55 !bg-yellow-soft hover:!border-yellow/70 hover:!brightness-[0.98]",
    activeClassName: "ring-2 ring-yellow ring-offset-2 ring-offset-card",
    iconClassName: "bg-yellow/35 text-primary shadow-sm",
    labelClassName: "font-semibold text-foreground",
  },
};

export function EnterpriseDashboardQuickAccess({
  items,
  activeId,
  onSelect,
}: EnterpriseDashboardQuickAccessProps) {
  return (
    <DashboardQuickAccess
      items={items}
      configById={quickAccessConfig}
      activeId={activeId}
      onSelect={onSelect}
    />
  );
}
